import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[wchfsControlErrorContainer]',
})
export class ControlErrorContainerDirective {
  constructor(public vcr: ViewContainerRef) {}
}
